export type FeatureFlagKey = 'feature3' | 'feature4';

type FeatureFlags = Record<FeatureFlagKey, boolean>;

export const featureFlagsConfig: FeatureFlags = {
  feature3: false,
  feature4: true,
};
